/**
 * httpInterceptActions - payloads of information that send data to our store.
 **/
import { clearSession, setCurrentUser } from "./loginActions";
import { showToast } from "./toastActions";
import { TWOFA_LOCKED_KEY } from "../components/twoFA/constants";

// Type of action being performed
export const HTTP_RESPONSE_NOT_FOUND = "HTTP_RESPONSE_NOT_FOUND";
export const HTTP_RESPONSE_FORBIDDEN = "HTTP_RESPONSE_FORBIDDEN";
export const HTTP_RESPONSE_INTERNAL_SERVER_ERROR = "HTTP_RESPONSE_INTERNAL_SERVER_ERROR";
export const HTTP_RESPONSE_UNAUTHORIZED = "HTTP_RESPONSE_UNAUTHORIZED";
export const HTTP_RESPONSE_GENERIC_ERROR = "HTTP_RESPONSE_GENERIC_ERROR";

function action(actionType, actionPayload) {
  return { type: actionType, payload: actionPayload };
}

const actions = {
  // handle API errors
  apiErrors: (err, status) => {
    switch (status) {
      case 407: // Proxy authentication
      case 401: {
        return (dispatch, state) => {
          const {
            login: { isAuthenticated },
          } = state;

          // Unauthorized
          dispatch(clearSession());
          if (err && err.body && err.body.messageKey === "NEW_SESSION_FOUND") {
            dispatch(
              showToast({
                message: "Detected log in from another device.",
              })
            );
          } else if (
            isAuthenticated &&
            err &&
            err.body &&
            err.body.messageKey != TWOFA_LOCKED_KEY
          ) {
            dispatch(
              showToast({
                message: "You have been logged out due to inactivity. Please login again.",
              })
            );
          }

          dispatch(action(HTTP_RESPONSE_UNAUTHORIZED, err.body));
          dispatch(setCurrentUser({}));
        };
      }
      case 404: // Not found
        return dispatch => dispatch(action(HTTP_RESPONSE_NOT_FOUND, err.body));
      case 403: // Forbidden
        return dispatch => dispatch(action(HTTP_RESPONSE_FORBIDDEN, err.body));
      case 502: // Bad Gateway
      case 500: // Internal Server error
        return dispatch => dispatch(action(HTTP_RESPONSE_INTERNAL_SERVER_ERROR, err.error));
      default:
        return dispatch => dispatch(action(HTTP_RESPONSE_GENERIC_ERROR, err.body));
    }
  },
};

export default actions;



// WEBPACK FOOTER //
// ./actions/httpInterceptActions.jsx